import {
  useEffect,
  useRef,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  Button,
  Box,
  Image,
  Skeleton,
  Stack,
  Text
} from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import { ImagesPng } from 'assets/images'
import {
  getComments,
  getNotificationMessage,
  getPosts,
  likePost,
  savePost,
  setBlogLikeOngoing,
  setBlogLinkToBeCopied,
  setBlogParent,
  setBlogRepostParent,
  setBlogSaveOngoing,
  setChosenBlogIndex,
  setCloseAllDrawers,
  setComments,
  setHideChat,
  setChatSectionPage,
  setRepostThisPostData,
  setSharingToFriends,
  subscribeToProfile,
  updateLastSeenOfPost
} from 'store'
import {
  LikeIcon,
  CommentIcon,
  RepostIcon,
  SaveIcon,
  ShareIcon
} from 'assets/icons'
import { LoadingSpinier } from 'common/Loading'
import {
  PENDING,
  REJECTED,
  STANDBY,
  SUCCEEDED
} from 'utils/constants'
import {
  AnimatePresence,
  motion
} from 'framer-motion'
import { QRCodeCanvas } from 'qrcode.react'
import {
  isMobile,
  isNotMobile,
  postTypeStatus
} from 'utils/helpers'
import { TextEditorReader } from 'components/UserSection/ProfileBlog/BlogList/TextEditorReader'
import { TextAnimation } from 'components/UserSection/ProfileBlog/BlogList/TextAnimation'
import { BlogPreview } from 'components/UserSection/ProfileBlog/BlogPreview'
import { AnimatedButton } from './styled'

const MotionStack = motion(Stack)
const MotionBtn = motion(Button)

export const BlogList = ({
  from,
  activeProfile,
  blogParent,
  blogRepostData,
  chosenBlogIndex,
  getPostsStatus,
  newPostsOption,
  posts,
  postsOption,
  profileItem,
  subscribeToProfileStatus,
  CommentSection,
  adminNotifications,
  widen,
  setWiden,
  GoToMarker
}) => {
  const dispatch = useDispatch()
  const [hideText, setHideText] = useState([])
  const [likeAnimate, setLikeAnimate] = useState([])
  const [saveAnimate, setSaveAnimate] = useState([])
  const [loadingMore, setLoadingMore] = useState(false)
  const [oldPostsCount, setOldPostsCount] = useState(0)
  const [loadSubsId, setLoadSubsId] = useState(0)
  const [loadedProfileImage, setLoadedProfileImage] = useState({})
  const [clickedQR, setClickedQR] = useState({})
  const [exitingBlogParentId, setExitingBlogParentId] = useState(null)
  const displayBlogParentId = blogParent.length > 0 ? blogParent[0].id : exitingBlogParentId

  const observer = useRef()
  const secondToLastItem = useRef(null)

  const handlePostsOption = blogRepostData?.length ? newPostsOption : postsOption

  const handleClickedQR = (id) => {
    setClickedQR((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }))
  }

  const handleProfileImage = (postId) => {
    setTimeout(() => {
      setLoadedProfileImage((prev) => ({
        ...prev,
        [postId]: true
      }))
    }, 500)
  }

  const hideTextMap = (id) => {
    setHideText((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }))
  }

  const animateLike = (id) => {
    setLikeAnimate((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }))

    setTimeout(() => {
      setLikeAnimate((prevState) => ({
        ...prevState,
        [id]: !prevState[id]
      }))
    }, 500)
  }

  const animateSave = (id) => {
    setSaveAnimate((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }))

    setTimeout(() => {
      setSaveAnimate((prevState) => ({
        ...prevState,
        [id]: !prevState[id]
      }))
    }, 500)
  }

  const noPostsMessage = () => {
    let msg = 'Article not existing'

    if (handlePostsOption.type === 'marker' || handlePostsOption.type === 'subscribed') {
      msg = 'This profile doesn\'t have any articles'

      if (
        activeProfile?.id !== profileItem?.id
        && activeProfile?.id !== handlePostsOption?.id
      ) {
        msg += '.\nSubscribe to stay tuned for future articles!'
      }
    } else if (handlePostsOption.type === 'affinity') {
      msg = 'There are no articles for this community'
    } else if (handlePostsOption.type === 'friends') {
      msg = 'No articles from your contacts yet'
    } else if (handlePostsOption.type === 'single') {
      msg = 'This article might be deleted, not existing, or unavailable'
    }

    return msg
  }

  const noPostSubscribeBtn = () => {
    if (
      subscribeToProfileStatus === PENDING
      && (
        (
          handlePostsOption.type === 'marker'
          && loadSubsId === profileItem.id
        ) || (
          handlePostsOption.type === 'subscribed'
          && loadSubsId === handlePostsOption.id
        )
      )
    ) {
      return (
        <LoadingSpinier
          width="12px"
          height="12px"
          marginTop="3px"
        />
      )
    }

    const isSubscribed = adminNotifications?.community_blogs?.find((blog) => {
      if (blog?.id === profileItem?.id || blog?.id === handlePostsOption?.id) {
        return true
      }

      return false
    })

    if (isSubscribed) {
      return 'Unsubscribe'
    }

    return 'Subscribe'
  }

  const goToHeaderOriginalPos = (index, targetName = '') => {
    if (from === 'normal-content') {
      if (targetName === '') {
        targetName = index === 0 ? '#hiddenItem' : '#blogEndItem' + (index - 1)
      }
      const targetElement = document.querySelector(targetName)

      if (targetElement) {
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: 'instant', block: 'start' })
        }, 10)
      }
    } else {
      document.querySelectorAll('.blogStartItem' + index).forEach((e) => {
        if (e.closest('.' + from)) {
          setTimeout(() => e.scrollIntoView({ behavior: 'instant', block: 'start' }), 10)
        }
      })
    }
  }

  const handleWalletQR = (item) => {
    if (item?.wallet_address) {
      handleClickedQR(item.id)
      setTimeout(() => handleClickedQR(item.id), 800)
      navigator.clipboard.writeText(item.wallet_address)
    }
  }

  useEffect(() => {
    let timer

    if (blogParent.length > 0) {
      setExitingBlogParentId(blogParent[0].id)
    } else if (chosenBlogIndex > -1) {
      timer = setTimeout(() => {
        setExitingBlogParentId(null)

        requestAnimationFrame(() => {
          if (from === 'normal-content') {
            const targetName = chosenBlogIndex === 0
              ? '#hiddenItem'
              : '#blogEndItem' + (chosenBlogIndex - 1)

            const el = document.querySelector(targetName)
            if (el) {
              el.scrollIntoView({ behavior: 'instant', block: 'start' })
            }
          }
        })
      }, 500)
    }

    return () => clearTimeout(timer)
  }, [blogParent, chosenBlogIndex, from])

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      // The "10" is the limit set on the backend DB query
      if (entries[0].isIntersecting && posts.length - oldPostsCount >= 10) {
        observer.current.unobserve(secondToLastItem.current)
        setLoadingMore(true)
        setOldPostsCount(posts.length)
        dispatch(getPosts({
          type: handlePostsOption.type,
          ...(handlePostsOption.type === 'affinity' ? { id: handlePostsOption.id } : {}),
          ...(handlePostsOption.type === 'marker' ? { id: profileItem.id } : {}),
          ...(handlePostsOption.type === 'subscribed' ? { id: handlePostsOption.id } : {}),
          lastItemId: posts.at(-1).id,
          lastDateTime: posts.at(-1).created_at
        }))
      }
    })

    const currentObserver = observer.current
    if (secondToLastItem.current && posts.length - oldPostsCount >= 10) {
      currentObserver.observe(secondToLastItem.current)
    }

    setLoadingMore(false)

    return () => {
      if (secondToLastItem.current) {
        observer.current.disconnect()
      }
    }
  }, [posts])

  useEffect(() => {
    if (!blogRepostData?.length) {
      setOldPostsCount(0)
    }
  }, [posts[0]?.id])

  useEffect(() => {
    if (getPostsStatus === SUCCEEDED) {
      dispatch(updateLastSeenOfPost())
    }
  }, [getPostsStatus])

  useEffect(() => {
    if (subscribeToProfileStatus === SUCCEEDED) {
      setLoadSubsId(0)
    }
  }, [subscribeToProfileStatus])

  return (
    <Stack
      className={from}
      gap="0"
      marginTop="-15px"
      position="relative"
    >
      <Text
        id="hiddenItem"
        position="absolute"
        opacity="0"
        top="-100"
        left="0"
        height="0"
        width="0"
        zIndex="-100"
      >
        qwe
      </Text>
      {
        getPostsStatus === STANDBY
        || (
          getPostsStatus === PENDING
          && !posts.length
        )
          ? (
            <Stack marginTop="100px">
              <LoadingSpinier />
            </Stack>
          ) : ''
      }
      {
        getPostsStatus !== STANDBY
        && posts
        && posts.length
          ? posts.map((item, index) => {
            let profilePicture = ''
            let fullName = ''
            const canGoToMarker = item.coordinates && item.coordinates.length && GoToMarker

            if (
              profileItem
              && handlePostsOption.type === 'marker'
              && !blogRepostData?.length
            ) {
              profilePicture = profileItem.profile_picture ?? ImagesPng.DefaultImage
              fullName = profileItem.full_name ?? ImagesPng.DefaultImage
            } else {
              profilePicture = item.profile_picture ?? ImagesPng.DefaultImage
              fullName = item.full_name ?? ImagesPng.DefaultImage
            }

            const subscribeBtn = () => {
              if (
                subscribeToProfileStatus === PENDING
                && loadSubsId === item?.profile_id
              ) {
                return (
                  <LoadingSpinier
                    width="12px"
                    height="12px"
                    marginTop="3px"
                  />
                )
              }

              if (item?.isSubscribed) {
                return 'Unsubscribe'
              }

              return 'Subscribe'
            }

            const imagesAreLoaded = (
              item.imageLoaded >= item.imageCount
                || !item?.imageCount
            )
            && (
              !item?.repost_post_id
              || item?.repostPostData?.imageLoaded >= item?.repostPostData?.imageCount
              || !item?.repostPostData?.imageCount === 0
            )

            return (
              <Stack
                id={'blogStartItem' + index}
                className={'blogStartItem' + index}
                ref={posts.length - 2 === index ? secondToLastItem : null}
                background={COLORS.whiteGrayGradientBotToTop}
                display={
                  !displayBlogParentId
                  || displayBlogParentId === item.id
                  || (
                    blogRepostData?.at(-1)?.id !== item.id
                    && from === 'repost-content'
                  )
                    ? 'flex'
                    : 'none'
                }
                border="solid 1px black"
                borderTop="none"
                borderBottom={posts.length - 1 === index ? 'auto' : 'none'}
                padding="50px 0px 10px 0px"
                marginTop="-50px"
                justifyContent="flex-start"
                gap="1rem"
                zIndex={900 - index}
              >
                <Stack
                  id={'stickyHeader' + item?.id}
                  position="sticky"
                  top={isMobile() ? '47.6px' : '48px'}
                  zIndex="210"
                  margin="0px 0px -10px 0px"
                  padding="0 5px 10px 5px"
                  backgroundColor={COLORS.white}
                  borderTop="solid 1px black"
                  boxShadow="0 4px 10px rgba(0, 0, 0, 0.2)"
                  style={{
                    transform: 'translateZ(0)',
                    WebkitTransform: 'translateZ(0)',
                    willChange: 'transform'
                  }}
                  _hover={{
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)'
                  }}
                >
                  <Stack
                    display="inline"
                    position="relative"
                  >
                    <Skeleton
                      isLoaded={loadedProfileImage[item.post_id]}
                      fadeDuration={1}
                      boxSize="55px"
                      position="relative"
                      objectFit="cover"
                      borderRadius="full"
                      display="inline-flex"
                      verticalAlign="bottom"
                      sx={{
                        '@media (max-width: 473px)': {
                          boxSize: '50px'
                        }
                      }}
                    >
                      <Image
                        src={
                          (
                            blogParent.length > 1
                            && from === 'normal-content'
                            && !blogRepostData?.length
                          )
                          || (
                            blogRepostData?.at(-1)?.id === item.id
                            && from === 'repost-content'
                            && blogParent.length > 1
                          )
                            ? blogParent.at(-1)?.profile_picture
                            : profilePicture
                        }
                        cursor={canGoToMarker ? 'pointer' : 'auto'}
                        borderRadius="full"
                        alt="User Image"
                        onClick={() => {
                          if (canGoToMarker) {
                            GoToMarker(
                              blogParent.length > 1 ? blogParent.at(-1) : item,
                              widen
                            )
                          }
                        }}
                        onLoad={() => handleProfileImage(item.post_id)}
                      />
                    </Skeleton>
                    <Text
                      display="inline-flex"
                      fontSize="16px"
                      lineHeight="28px"
                      wordBreak="break-word"
                      margin="10px 0 0 7.5px !important"
                      sx={{
                        '@media (max-width: 473px)': {
                          ...(postsOption.type === 'marker'
                            ? { fontSize: '14px' } : ''
                          ),
                          lineHeight: '25px'
                        }
                      }}
                    >
                      <Box display="contents">
                        {
                          (
                            blogParent.length > 1
                            && from === 'normal-content'
                            && !blogRepostData?.length
                          )
                          || (
                            blogRepostData?.at(-1)?.id === item.id
                            && from === 'repost-content'
                            && blogParent.length > 1
                          )
                            ? blogParent.at(-1)?.full_name
                            : fullName
                        }
                      </Box>
                      <br />
                      <Box
                        display="contents"
                        letterSpacing="-1px"
                      >
                        {
                          postTypeStatus({
                            item: (
                              blogParent.length > 1
                              && from === 'normal-content'
                              && !blogRepostData?.length
                            )
                            || (
                              blogRepostData?.at(-1)?.id === item.id
                              && from === 'repost-content'
                              && blogParent.length > 1
                            )
                              ? blogParent.at(-1)
                              : item,
                            noLabel: true
                          })
                        }
                      </Box>
                    </Text>
                    {
                      activeProfile?.id !== item.profile_id
                      && item?.wallet_address !== null
                      && blogParent.length < 2
                        ? (
                          <Stack
                            position="absolute"
                            right="75px"
                            bottom="0"
                            border="solid 1px black"
                            borderRadius="5px"
                            padding="2.3px"
                            cursor="pointer"
                            onClick={() => handleWalletQR(item)}
                            pointerEvents={clickedQR[item.id] ? 'none' : 'auto'}
                          >
                            <QRCodeCanvas value={item?.wallet_address} size={23} />
                          </Stack>
                        ) : ''
                    }
                    {
                      activeProfile?.id === item.profile_id
                      || (
                        blogParent.length > 1
                        && from === 'normal-content'
                        && !blogRepostData?.length
                      )
                      || (
                        blogRepostData?.at(-1)?.id === item.id
                        && from === 'repost-content'
                        && blogParent.length > 1
                      )
                        ? ''
                        : (
                          <Button
                            onClick={() => {
                              setLoadSubsId(
                                profileItem?.id
                                && handlePostsOption.type === 'marker'
                                && !blogRepostData?.length
                                  ? profileItem?.id
                                  : item?.profile_id
                              )
                              dispatch(subscribeToProfile({
                                subscribeId:
                                  profileItem?.id
                                  && handlePostsOption.type === 'marker'
                                  && !blogRepostData?.length
                                    ? profileItem?.id
                                    : item?.profile_id,
                                postId: item?.id
                              }))
                            }}
                            width="70px"
                            height="30px"
                            fontSize="13px"
                            letterSpacing="-1px"
                            fontWeight="400"
                            position="absolute"
                            right="0"
                            bottom="0"
                            backgroundColor={COLORS.gold}
                            _hover={{ background: COLORS.gold_hover }}
                            pointerEvents={subscribeToProfileStatus === PENDING ? 'none' : 'auto'}
                            sx={{
                              '@media (max-width: 473px)': {
                                ...(postsOption.type === 'marker'
                                  ? {
                                    fontSize: '12px',
                                    width: '65px'
                                  } : ''
                                )
                              }
                            }}
                          >
                            {subscribeBtn()}
                          </Button>
                        )
                    }
                  </Stack>

                  <Stack
                    display="flex"
                    justifyContent="center"
                    direction="row"
                  >
                    <MotionBtn
                      initial={{
                        background: hideText[item.id]
                          ? COLORS.lightGoldGradientLeftToRight
                          : COLORS.darkGrayGradientBotToTop,
                        fontSize: '19px'
                      }}
                      animate={{
                        background: hideText[item.id]
                          ? COLORS.darkGrayGradientBotToTop
                          : COLORS.lightGoldGradientLeftToRight,
                        fontSize: widen ? '23px' : '19px'
                      }}
                      transition={{
                        fontSize: { duration: 0.8 }
                      }}
                      whileTap={{ scale: 0.95 }}
                      padding="2px 0"
                      width="100%"
                      borderRadius="5px"
                      align="center"
                      letterSpacing=".15px"
                      fontWeight="400"
                      _hover={{
                        background: ''
                      }}
                      _active={{
                        background: ''
                      }}
                      onClick={() => {
                        goToHeaderOriginalPos(index)
                        hideTextMap(item.id)
                      }}
                      pointerEvents={
                        blogParent.length
                          ? 'none'
                          : 'auto'
                      }
                      display="block"
                      overflow="hidden"
                      position="relative"
                    >
                      <Box
                        position="absolute"
                        backgroundColor="white"
                        top="50%"
                        left="50%"
                        transform="translate(-50%, -50%)"
                        width="97%"
                        paddingY="2px"
                        borderRadius="5px"
                        zIndex="3"
                        opacity={clickedQR[item.id] ? '1' : '0'}
                        transition={clickedQR[item.id] ? '' : '0.8s ease'}
                      >
                        Copied To Clipboard
                      </Box>
                      <TextAnimation
                        item={item}
                        blogParent={blogParent}
                        widen={widen}
                        place={handlePostsOption?.type}
                      />
                    </MotionBtn>
                  </Stack>

                  <MotionStack
                    initial={{ x: 0 }}
                    animate={{ height: hideText[item.id] ? '0px' : 'auto' }}
                    transition={{
                      type: 'spring',
                      stiffness: 300,
                      damping: 60
                    }}
                    direction="row"
                    flexWrap="wrap"
                    overflow="hidden"
                    justifyContent="center"
                    margin="-2.5px 0"
                    display={
                      (
                        blogParent.length > 1
                        && from === 'normal-content'
                        && !blogRepostData?.length
                      )
                      || (
                        blogRepostData?.at(-1)?.id === item.id
                        && from === 'repost-content'
                        && blogParent.length > 1
                      )
                        ? 'none'
                        : 'flex'
                    }
                  >
                    {
                      item.affinities.length
                        ? item.affinities.map((e) => (
                          <Box
                            color="#F8F8FF"
                            border="solid 1px black"
                            borderRadius="5px"
                            bg={COLORS.gold}
                            p="0 2px"
                            data-name="blog-affinity"
                            fontSize={widen ? '15px' : '11px'}
                            transition="font-size 0.8s"
                            margin="2.5px 0px"
                            overflow="hidden"
                          >
                            {e.title}
                          </Box>
                        ))
                        : (
                          <Box
                            color="#F8F8FF"
                            border="solid 1px black"
                            borderRadius="5px"
                            bg={COLORS.gold}
                            p="0 2px"
                            data-name="blog-affinity"
                            fontSize={widen ? '15px' : '11px'}
                            transition="font-size 0.8s"
                            overflow="hidden"
                          >
                            No Affinities
                          </Box>
                        )
                    }
                  </MotionStack>
                </Stack>

                <Stack
                  className="article-body"
                  display="grid"
                  sx={{
                    '& > *': {
                      gridArea: '1 / 1',
                      minWidth: 0,
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain'
                    }
                  }}
                  height="100%"
                  position="relative"
                >
                  <AnimatePresence mode="sync">
                    {
                      blogParent.length
                      && blogParent[0].id === item.id
                        ? (
                          <MotionStack
                            key="comment-section"
                            initial={{ x: widen && isNotMobile() ? '70svw' : 450 }}
                            animate={{ x: 0 }}
                            exit={{ x: widen && isNotMobile() ? '70svw' : 450 }}
                            transition={{
                              type: 'tween',
                              duration: 0.8
                            }}
                            width="100%"
                            height="100%"
                            zIndex={2}
                            transformOrigin="top"
                          >
                            {CommentSection}
                          </MotionStack>
                        ) : ''
                    }
                    <MotionStack
                      initial={{ height: 'auto' }}
                      animate={{
                        height: blogParent.length && blogParent[0].id === item.id ? 0 : 'auto',
                        display: 'flex'
                      }}
                      exit={{
                        height: blogParent.length && blogParent[0].id === item.id ? 'auto' : 0,
                        display: 'grid'
                      }}
                      transition={{
                        delay: blogParent.length && blogParent[0].id === item.id ? 0.8 : 0
                      }}
                      display={blogParent.length && blogParent[0].id ? 'flex' : 'grid'}
                    >
                      <MotionStack
                        key="post-body"
                        initial={{ x: 0, height: 'auto' }}
                        animate={{ height: hideText[item.id] ? '0px' : 'auto' }}
                        transition={{
                          type: 'spring',
                          stiffness: 300,
                          damping: 60
                        }}
                        display="block"
                        width="100%"
                        mx="auto"
                        overflow="hidden"
                        padding="0px 5px"
                      >
                        <TextEditorReader
                          dispatch={dispatch}
                          item={item}
                          widen={widen}
                          setCloseAllDrawers={setCloseAllDrawers}
                        />

                        {
                          item?.has_repost
                            ? (
                              <BlogPreview
                                from="blogListFromBlogModal"
                                item={item?.repostPostData}
                                blogParent={blogParent}
                                GoToMarker={GoToMarker}
                                widen={widen}
                              />
                            ) : ''
                        }
                      </MotionStack>

                      <Stack padding="0px 5px">
                        <Stack
                          id={'blogEndItem' + index}
                          width="100%"
                          height="29px"
                          direction="row"
                          border="solid 1px black"
                          borderRadius="5px"
                          padding="1.5px 15px"
                          justifyContent="space-around"
                          zIndex={1}
                          background={COLORS.whiteYellowGradientTopToBot}
                          gap="0"
                          mx="auto"
                        >
                          <AnimatedButton className={likeAnimate[item.id] ? 'animate' : ''}>
                            <Stack
                              as="button"
                              zIndex={1}
                              onClick={() => {
                                if (activeProfile?.id) {
                                  if (!item?.likeOngoing) {
                                    animateLike(item.id)
                                    dispatch(setBlogLikeOngoing({
                                      id: item.id,
                                      type: 'post'
                                    }))
                                    dispatch(likePost(item.id))
                                  }
                                } else {
                                  dispatch(
                                    getNotificationMessage({
                                      type: REJECTED,
                                      message: 'You do not have an active profile. Please setup your profile first.',
                                      isEditProfile: true
                                    })
                                  )
                                }
                              }}
                            >
                              <LikeIcon fill={item.likedByMe ? COLORS.gold : 'none'} />
                            </Stack>
                            <Text fontSize="15px">{item.likes}</Text>
                          </AnimatedButton>

                          <Stack
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            zIndex={1}
                          >
                            <Stack
                              onClick={() => {
                                if (activeProfile) {
                                  if (blogParent.length && chosenBlogIndex >= 0) {
                                    goToHeaderOriginalPos(chosenBlogIndex)

                                    dispatch(
                                      getNotificationMessage({
                                        type: REJECTED,
                                        message: 'A comment section is still open',
                                        isEditProfile: false
                                      })
                                    )
                                  } else {
                                    dispatch(setChosenBlogIndex(index))
                                    goToHeaderOriginalPos(index, '#hiddenItem')

                                    if (blogRepostData?.length) {
                                      dispatch(setBlogRepostParent([item]))
                                    } else {
                                      dispatch(setBlogParent([item]))
                                    }

                                    dispatch(setComments([]))
                                    dispatch(getComments({
                                      type: 'post',
                                      post_id: item.id
                                    }))
                                  }
                                } else {
                                  dispatch(
                                    getNotificationMessage({
                                      type: REJECTED,
                                      message: 'You do not have an active profile. Please setup your profile first.',
                                      isEditProfile: true
                                    })
                                  )
                                }
                              }}
                            >
                              <CommentIcon />
                            </Stack>
                            <Text fontSize="15px">{item.comments}</Text>
                          </Stack>

                          <Stack
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            zIndex={1}
                            cursor={imagesAreLoaded ? 'auto' : 'not-allowed'}
                          >
                            <Stack
                              pointerEvents={imagesAreLoaded ? 'auto' : 'none'}
                              onClick={() => {
                                if (window.location.href.includes('?id=')) {
                                  const blogModalOverlay = document.querySelector('#blog-modal-overlay')
                                  if (blogModalOverlay) {
                                    blogModalOverlay.click()
                                  }

                                  dispatch(setRepostThisPostData(item))
                                  setTimeout(() => {
                                    document.querySelector('.profile-icon').click()
                                  }, 1550)
                                } else {
                                  dispatch(setRepostThisPostData(item))
                                  dispatch(setCloseAllDrawers(true))

                                  setTimeout(() => {
                                    dispatch(setCloseAllDrawers(false))
                                    document.querySelector('.profile-icon').click()
                                  }, 1050)
                                }
                              }}
                            >
                              <RepostIcon />
                            </Stack>
                            <Text fontSize="15px">{item?.reposts}</Text>
                          </Stack>

                          <Stack
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            zIndex={1}
                          >
                            <Stack
                              as="button"
                              onClick={() => {
                                const modalBlogDrawer = document.querySelector('#blog-panel')

                                if (
                                  modalBlogDrawer
                                  && modalBlogDrawer.offsetWidth * 3.5 >= document.querySelector('body').offsetWidth
                                  && isNotMobile()
                                ) {
                                  if (widen && setWiden) {
                                    setWiden(false)
                                  }
                                }

                                dispatch(setChatSectionPage('chat-main'))
                                dispatch(setSharingToFriends(true))
                                dispatch(setHideChat(false))
                                dispatch(setBlogLinkToBeCopied(window.location.origin + '/?post-id=' + item?.id))
                                sessionStorage.setItem('isSharingBlog', 'true')
                                window.dispatchEvent(new CustomEvent('isSharingBlog-changed'))
                              }}
                            >
                              <ShareIcon />
                            </Stack>
                            <Text fontSize="15px">{ item.shares }</Text>
                          </Stack>

                          <AnimatedButton className={saveAnimate[item.id] ? 'animate' : ''}>
                            <Stack
                              as="button"
                              zIndex={1}
                              onClick={() => {
                                if (activeProfile?.id) {
                                  if (!item?.saveOngoing) {
                                    animateSave(item.id)
                                    dispatch(setBlogSaveOngoing(item.id))
                                    dispatch(savePost(item.id))
                                  }
                                } else {
                                  dispatch(
                                    getNotificationMessage({
                                      type: REJECTED,
                                      message: 'You do not have an active profile. Please setup your profile first.',
                                      isEditProfile: true
                                    })
                                  )
                                }
                              }}
                            >
                              <SaveIcon
                                width="18"
                                height="18"
                                viewBox="0 2 22 22"
                                fill={item.savedByMe ? COLORS.gold : 'none'}
                              />
                            </Stack>
                            <Text fontSize="15px">{item.saves}</Text>
                          </AnimatedButton>
                        </Stack>
                      </Stack>
                    </MotionStack>
                  </AnimatePresence>
                </Stack>
              </Stack>
            )
          })
          : (
            <Stack
              initial={{ x: 100 }}
              animate={{ x: 0 }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 60
              }}
            >
              {
                getPostsStatus === STANDBY
                || (
                  getPostsStatus === PENDING
                  && !posts.length
                )
                  ? ''
                  : (
                    <Stack
                      alignItems="center"
                      backgroundColor="rgb(229, 229, 229)"
                      borderRadius="3px"
                      border="solid 1px black"
                      padding={handlePostsOption.type === 'subscribed' ? '20px' : '10px'}
                      margin="10px 2% !important"
                    >
                      <Text
                        textAlign="center"
                        fontSize={widen ? '17px' : '13px'}
                        whiteSpace="pre-line"
                        transition={'font-size 0.8s, ' + (handlePostsOption.type === 'subscribed' ? '0.6s' : '0.3s')}
                      >
                        { noPostsMessage() }
                      </Text>

                      {
                        activeProfile?.id !== profileItem?.id
                        && activeProfile?.id !== handlePostsOption?.id
                        && (
                          handlePostsOption.type === 'marker'
                          || handlePostsOption.type === 'subscribed'
                        )
                          ? (
                            <Button
                              onClick={() => {
                                let willSubId = 0
                                if (handlePostsOption.type === 'marker') {
                                  willSubId = profileItem.id
                                } else if (handlePostsOption.type === 'subscribed') {
                                  willSubId = handlePostsOption.id
                                }

                                setLoadSubsId(willSubId)
                                dispatch(subscribeToProfile({
                                  subscribeId: willSubId
                                }))
                              }}
                              width="105px"
                              height="30px"
                              fontSize="16px"
                              fontWeight="400"
                              margin="5px"
                              backgroundColor={COLORS.gold}
                              _hover={{
                                background: COLORS.gold_hover
                              }}
                              pointerEvents={subscribeToProfileStatus === PENDING ? 'none' : 'auto'}
                            >
                              {noPostSubscribeBtn()}
                            </Button>
                          ) : ''
                      }
                    </Stack>
                  )
              }
            </Stack>
          )
      }
      {
        loadingMore && getPostsStatus === PENDING
          ? (
            <Stack margin="75px 0 60px 0">
              <LoadingSpinier />
            </Stack>
          ) : ''
      }
    </Stack>
  )
}
